import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { getFullCancellationVariant } from '@/scopes/account/booking-details/pages/selectors/fullCancellationSelectors'
import { FullCancellationFreeConfirmationStep } from './FullCancellationFreeConfirmationStep'
import { FullCancellationWithCostConfirmationStep } from './FullCancellationWithCostConfirmationStep'

export function FullCancellationConfirmationStep() {
  const variant = useBookingDetailsStore(getFullCancellationVariant)

  if (variant === 'free')
    return <FullCancellationFreeConfirmationStep />

  if (variant === 'with-cost')
    return <FullCancellationWithCostConfirmationStep />

  return null
}
